import moment from 'moment';
import { FRONT_DF_1 } from 'CONST';
import store from '../redux-store/store/index';

export const detalleList = [
  {
    tipo_id: 1,
    label: 'Exposición Máxima',
    nemotecnico: 'exposicion_maxima',
  },
  {
    tipo_id: 2,
    label: 'Línea',
    nemotecnico: 'linea',
  },
  {
    tipo_id: 3,
    label: 'Cúmulo',
    nemotecnico: 'cumulo',
  },
  {
    tipo_id: 7,
    label: 'Línea Proyectos',
    nemotecnico: 'linea_proyectos',
  },
  {
    tipo_id: 8,
    label: 'Cúmulo Proyectos',
    nemotecnico: 'cumulo_proyectos',
  },
];

export const detalleListNotVentaVerde = [
  {
    tipo_id: 1,
    label: 'Exposición Máxima',
    nemotecnico: 'exposicion_maxima',
  },
  {
    tipo_id: 2,
    label: 'Línea',
    nemotecnico: 'linea',
  },
  {
    tipo_id: 3,
    label: 'Cúmulo',
    nemotecnico: 'cumulo',
  },
];

export const detalleTripleLines = [
  {
    block_name: 'Línea',
    block_id: 1,
    label_first: 'General',
    nemotecnico_first: 'linea',
    tipo_id_first: 2,
    label_second: 'Venta en Verde',
    nemotecnico_second: 'linea_proyectos',
    tipo_id_second: 7,
    total: 'linea_total',
  },
  {
    block_name: 'Cúmulo',
    block_id: 2,
    label_first: 'General',
    nemotecnico_first: 'cumulo',
    tipo_id_first: 3,
    label_second: 'Venta en Verde',
    nemotecnico_second: 'cumulo_proyectos',
    tipo_id_second: 8,
    total: 'cumulo_total',
  },
];

export const balanceFields = {
  'exposicion-maxima': 'exposicion_maxima',
  linea: 'linea',
  cumulo: 'cumulo',
  bloqueo: 'bloqueada',
  'linea-indirecto': 'linea_indirecta',
  'cumulo-indirecto': 'cumulo_indirecto',
};

export const handleKey = (key) => {
  switch (key) {
    case 'exposicion_maxima':
      return { tipo_id: 1, label: 'Exposición Máxima', nemotecnico: 'exposicion_maxima' };
    case 'linea':
      return { tipo_id: 2, label: 'Línea', nemotecnico: 'linea' };
    case 'linea_indirecta':
      return { tipo_id: 5, label: 'Línea Indirecta', nemotecnico: 'linea_indirecta' };
    case 'cumulo_indirecto':
      return { tipo_id: 6, label: 'Cúmulo Indirecto', nemotecnico: 'cumulo_indirecto' };
    case 'linea_proyectos':
      return { tipo_id: 7, label: 'Línea Proyectos', nemotecnico: 'linea_proyectos' };
    case 'cumulo_proyectos':
      return { tipo_id: 8, label: 'Cúmulo Proyectos', nemotecnico: 'cumulo_proyectos' };
    default:
      return { tipo_id: 3, label: 'Cúmulo', nemotecnico: 'cumulo' };
  }
};

export const setFontSize = (num) => {
  const string = num.toString();
  const fontSize = string.length > 12 ? 36 - 3 * (12 / 2) : 36;
  return `${fontSize}px`;
};

export const fileDownload = (downloadUrl, id, handleLoading) => {
  const { login } = store.getState();
  const xhr = new XMLHttpRequest();
  xhr.open('GET', `${downloadUrl}${id}`, true);
  xhr.responseType = 'blob';
  xhr.setRequestHeader('Authorization', `JWT ${login.id_token}`);
  xhr.onload = function onload() {
    if (this.status === 200) {
      const content = xhr.getResponseHeader('Content-Disposition');
      let filename = '';
      if (content.includes('filename=')) {
        filename = content.split('filename=')[1].replace(/^"+|"+$/g, '');
      } else {
        filename = decodeURI(content.split("filename*=utf-8''")[1].replace(/^"+|"+$/g, ''));
      }
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(new Blob([this.response]));
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 1000);
    }
    if (handleLoading) {
      handleLoading();
    }
  };
  xhr.send();
};

export const fdate = (date, format = FRONT_DF_1) => (date ? moment(date).format(format) : '');

export const bytesToMb = (number) => (number / 1024 / 1024).toFixed(2);

export const mbToBytes = (number) => number * 1024 * 1024;

export const apelable = (fechaRespuesta) => {
  const fechaHoy = moment();
  const momentRespuesta = moment(fechaRespuesta);
  const deltaDias = fechaHoy.diff(momentRespuesta, 'days');
  return deltaDias <= 30;
};
